import clsx from "clsx";
import { ReactNode } from "react";

import { FCCC } from "@/types";

/**
 * The rounded panel every row of the "Dein Abo" container sits in.
 */
export const SubscriptionInfoBox: FCCC = ({ className, children }) => (
  <div
    className={clsx(
      "w-full overflow-hidden rounded-md bg-surface-quaternary p-4",
      className,
    )}
  >
    {children}
  </div>
);

export interface SubscriptionInfoRowProps {
  icon: ReactNode;
  title: string;
  /** The included volume, e.g. "2 GB" or "Unlimitiert". */
  detail?: string;
}

/** Icon plus a two-line label, used for every included subscription option. */
export const SubscriptionInfoRow = ({
  icon,
  title,
  detail,
}: SubscriptionInfoRowProps) => (
  <div className="flex w-full items-center gap-2">
    <span className="shrink-0 text-foreground-primary">{icon}</span>
    <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
      <p className="truncate-safe text-body-base font-semibold leading-none text-foreground-primary">
        {title}
      </p>
      {detail && (
        <p className="truncate-safe text-body-xs leading-none text-foreground-secondary">
          {detail}
        </p>
      )}
    </div>
  </div>
);

export interface SubscriptionInfoGroupProps {
  /** Section label above the rows, e.g. "Schweiz" or "International". */
  label: string;
  children: ReactNode;
}

export const SubscriptionInfoGroup = ({
  label,
  children,
}: SubscriptionInfoGroupProps) => (
  <SubscriptionInfoBox className="flex flex-col justify-center gap-2">
    <p className="truncate-safe text-body-sm font-semibold leading-none text-foreground-secondary">
      {label}
    </p>
    {children}
  </SubscriptionInfoBox>
);
